import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Auth } from '@aws-amplify/auth';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import endUserMessages from 'utils/endUserMessages';
import loadUser from './loadUser';
var updateUserAttributes = function updateUserAttributes(user, attributes) {
  var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Auth.updateUserAttributes(user, attributes);
            case 3:
              _context.next = 5;
              return dispatch(loadUser());
            case 5:
              pushNotificationMessage('success', endUserMessages.ACCOUNT_DETAILS_UPDATED, 3);
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              pushNotificationMessage('error', 'Something went wrong while updating your account details', 3);
              onError();
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateUserAttributes;